module.exports = "<!-- <div>D3SankyChartComponent</div> -->\r\n<div id=\"d3-flowchart-sanky\" #sankyChartNewRef ></div>"